import React from 'react';
import bemHelper from 'react-bem-helper';
import Rating from '../RatingModule/RatingModule';
import './styles.scss';
import * as constants from '../../constants';
import { replaceStyleImageUri } from '../../utils';
import ReadMore from '../Comment/ReadMore';
import reviewsAnalytics from '../../analytics/reviews';

const bem = bemHelper({ prefix: 'toga-', name: 'storefront-review' });

class Review extends ReadMore {

  componentWillReceiveProps() {
    this.setState({ maxHeight: 94 });
  }

  clickAnchorHandler(idReview) { //eslint-disable-line
    reviewsAnalytics.registryReview(idReview);
  }

  render() {
    const { id, image, link, comment, rating, author } = this.props;
    const withProduct = !!image;
    const classes = this.getClasses();

    return (
      <li {...bem(null, classes)}>
        {
          withProduct &&
          <div {...bem('header', classes)}>
            <figure {...bem('image', classes)}>
              <img src={replaceStyleImageUri(image, constants.IMAGE_SIZE_NORMAL)}
                   alt={'image of the product related to this review'}/>
            </figure>
            <div {...bem('overlay', classes)}>
              <a onClick={this.clickAnchorHandler.bind(this, id)}
                 {...bem('link', classes)}
                 href={link}>View Product</a>
              <div className="sr-only">link to view product</div>
            </div>
          </div>
        }
        <article {...bem('body', classes)}>
          <div ref="textContainer"
               onMouseLeave={this.onMouseLeaveHandler.bind(this)}
               {...bem('text', classes)}>
            <span {...bem('quot_left', classes)}>"</span>
            {comment}
            <span {...bem('quot_right', classes)}>"</span>
          </div>
          <div {...bem('read-more', classes)}
               onClick={this.onMouseOverHandler.bind(this)}>read more</div>

          {withProduct && <Rating {...bem('rating')} rating={+rating}/>}
          {
            !rating && <p {...bem('author')}>{author || 'Unknown'}</p>
          }
          {
            rating && <p {...bem('independent')}>Independent review</p>
          }
        </article>
      </li>
    );
  }
}

Review.propTypes = {
  image: React.PropTypes.string,
  comment: React.PropTypes.string,
  rating: React.PropTypes.number,
  date: React.PropTypes.string,
};

export default Review;



// WEBPACK FOOTER //
// ./src/components/storefront/components/Review/Review.js